export default __webpack_public_path__ + "static/media/hair-1-1.0e193d71.svg";